import { useState, useEffect } from "react"
import { useEditTaskBaseActionMutation, useDeleteTaskBaseActionMutation } from "../taskBasesApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faFillDrip, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { ACTION_TYPES } from "../../../config/types"
import Uploader from "../../../partial/Uploader"
import Addition from "./Addition"


const EditActionForm = ({ action }) => {
    const {taskBaseId, groupId, type:urlType} = useParams()

    const [updateAction, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useEditTaskBaseActionMutation()

    const [deleteAction, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteTaskBaseActionMutation()
  
    const navigate = useNavigate()

    const [img, setImg] = useState(action.img)
    const [text, setText] = useState(action.text)
    const [title, setTitle] = useState(action.title)
    const [type, setType] = useState(action.type)
    const [booleans, setBooleans] = useState(action.booleans)
    const [active, setActive] = useState(action.active)
    const [order, setOrder] = useState(action.order)
    const [additions, setAdditions] = useState(action.additions || [])
    const [language, setLanguage] = useState(action.language )
    const [highlight, setHighlight] = useState(action.highlight || false)
    const [ratio, setRatio] = useState(action.ratio || 0)

    const [num, setNum] = useState(1)
    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setImg('')
            setTitle('')
            setText('')
            setType('Code')
            setActive(true)
            navigate(`/${urlType}/${groupId}/task-bases/${taskBaseId}`)
        }

    }, [isSuccess, isDelSuccess, taskBaseId, groupId, navigate])


    const canSave = [ title, type].every(Boolean) && !isLoading

    const onSaveActionClicked = async (e) => {
        if (canSave) {
            await updateAction({ id: action._id, taskBaseId, title, text, img, type, active,order, additions, booleans, highlight, language, ratio })
        }
    }

    const onDeleteActionClicked = async () => {
        await deleteAction({ id: action._id, taskBaseId })
    }


    const onBackClick = () =>{
        navigate(`/${urlType}/${groupId}/task-bases/${taskBaseId}`)
    }

    const created = new Date(action.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(action.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    const options = ACTION_TYPES.map(type => {
        return (
            <option
                key={type}
                value={type}
            > {type}</option >
        )
    })

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
  
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''
    const changeAddition = (id,newAddition) =>{
        if(id==='-1') {
            const newObj = {...newAddition, _id:num.toString(), required:true}
            setNum(num+1)
            setAdditions([...additions, newObj])
        }
        else{
            if(newAddition) //update
            {
                const additionsList = additions.map((addition, inx)=>{
                    return  addition._id ===id ? newAddition : addition
                })
                setAdditions(additionsList)
            }
            else { //delete
                setAdditions(additions.filter((addition) => addition._id!==id))
            }
        }
    }

    const   deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteActionClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )



    const content = (
        <>
            <p className={errClass}>{errContent}</p>
            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Action </h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to Task"
                            onClick={onBackClick}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveActionClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                    </div>
                </div>  

                <label className="form__label" htmlFor="action-title">
                    Short title</label>
                <input type="text" id="action-title" 
                value={title} onChange={(e)=>setTitle(e.target.value)}
                className={`form__input ${!title && 'form__input--incomplete'}` }
                maxLength={20}
                 />
               
                <label className="form__label" htmlFor="action-text">
                    Text:</label>
                <textarea
                    className={`form__input form__input--text`}
                    id="action-text"
                    name="text"
                    value={text}
                    onChange={(e)=>setText(e.target.value)}
                />
                <Uploader label={'Img'} folderId={'MANAGE_ACTIONS'} file={img} setFile={setImg} isImg={true} />
                                <div className="form-flex">
               
               <div  className="form-input-container">
               <label className="form__label form__checkbox-container" htmlFor="action-type">
                           TYPE:</label>
                       <select
                            disabled
                            readOnly
                           id="action-type"
                           name="type"
                           className={`form__input`}

                           value={type}
                           onChange={(e)=>setType(e.target.value)}
                       >
                           {options}
                       </select>
               </div>
               <div className="form__row">
                    <div className="form__divider">
                        <label  className="form__label form__checkbox-container" htmlFor={`action-highlight-main`}>
                           Highlight:
                            <input
                                disabled={type!=="Code"}
                                className="form__checkbox"
                                id={`action-highlight-main`}
                                name="highlight"
                                type="checkbox"
                                checked={highlight}
                                onChange={(e)=>setHighlight( prev => !prev)}
                            />
                        </label>
{highlight && <select name="language" disabled={type!=="Code"}  id={`action-language-main`} value={language} onChange={(e)=>setLanguage(e.target.value)}>
                            <option ></option>
                                <option value={"javascript"} >JS</option>
                                <option value={"html"} >HTML</option>
                                <option value={"css"} >CSS</option>
                           </select>
}

                        
                    </div>                   
                </div>
               <div  className="form-input-container">

                   <label className="form__label" htmlFor="action-order">
                   Order:</label>
                   <input
                   className={`form__input `}
                   id="action-order"
                   name="order"
                   type="number"
                   autoComplete="off"
                   value={order}
                   onChange={(e)=>setOrder(e.target.value)}
                   />
                   </div >
               </div>
               <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>
               {(type==="Code" || type=="Text") && <button type="button" className="bg-white p-2 rounded"   onClick={()=>changeAddition('-1',{})}>+</button>}
{additions.map((addition,inx)=><Addition key={addition._id} id={addition._id} addition={addition}  changeAddition={changeAddition} />) }
<label className="form__label" htmlFor="action-booleans">
                    Booleans: (each value in new line) </label>
                <textarea
                    className={`form__input form__input--text`}
                    id="action-booleans"
                    name="text"
                    value={booleans}
                    onChange={(e)=>setBooleans(e.target.value)}
                />
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="action-active">
                           ACTIVE:
                            <input
                                className="form__checkbox"
                                id="action-active"
                                name="number"
                                type="checkbox"
                                checked={active}
                                onChange={(e)=>setActive( prev => !prev)}
                            />
                        </label>
                    </div>
                   
                    <div className="form__divider">
                        <p className="form__created">Created:<br />{created}</p>
                        <p className="form__updated">Updated:<br />{updated}</p>
                    </div>
                </div>
            </form>
        </>
    )

    return content
}

export default EditActionForm